import { scoped } from "../chunks/vidstack-D9mvYVIz.js";
import { HTMLMediaProvider } from "../chunks/vidstack-BFrlqsuF.js";
import { HTMLAirPlayAdapter } from "../chunks/vidstack-CI5oafcm.js";
//#region src/providers/audio/provider.ts
/**
* The audio provider adapts the `<audio>` element to enable loading audio via the HTML Media
* Element API.
*
* @docs {@link https://www.vidstack.io/docs/player/providers/audio}
* @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/audio}
* @example
* ```html
* <media-player src="https://files.vidstack.io/audio.mp3">
*   <media-provider></media-provider>
* </media-player>
* ```
*/
var AudioProvider = class extends HTMLMediaProvider {
	$$PROVIDER_TYPE = "AUDIO";
	get type() {
		return "audio";
	}
	airPlay;
	constructor(audio, ctx) {
		super(audio, ctx);
		scoped(() => {
			this.airPlay = new HTMLAirPlayAdapter(this.media, ctx);
		}, this.scope);
	}
	setup() {
		super.setup();
		if (this.type === "audio") this.ctx.notify("provider-setup", this);
	}
	/**
	* The native HTML `<audio>` element.
	*
	* @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement}
	*/
	get audio() {
		return this.media;
	}
};
//#endregion
export { AudioProvider };
